module.exports = __webpack_public_path__ + "img/resources-entry.1b9aa840.jpg";